import { partial } from 'superstruct';

import { SortQueryDefaulted } from '@adflow/shared/util-data';

import type { ViewGoogleAdsTemplateDto } from './google-ads-template.dto';

const GoogleAdsTemplateSortableFields: (keyof ViewGoogleAdsTemplateDto)[] = [
	'id',
	'name',
	'createdAt',
	'updatedAt',
	'archived',
	'salesforceImport',
] as const;

export const DEFAULT_GOOGLE_ADS_TEMPLATE_SORT = 'updatedAt';
export const DEFAULT_GOOGLE_ADS_TEMPLATE_SORT_DIR = 'desc';

export const ListGoogleAdsTemplateSort = partial(
	SortQueryDefaulted(
		GoogleAdsTemplateSortableFields,
		DEFAULT_GOOGLE_ADS_TEMPLATE_SORT,
		DEFAULT_GOOGLE_ADS_TEMPLATE_SORT_DIR
	)
);
